/**
 * Store de reportes
 * --------------------------------------------
 *
 * contiene la store de reportes
 *
 */
import { getReportData } from "@/utils/ReportService.js";

export default {
  namespaced: true,
  state: {
    reportState: { name: "test" },
    reportList: {},
  },
  mutations: {
    saveReport(state, report) {
      state.reportState = report;
    },
    updateReportList(state, payload) {
      state.reportList = payload;
    },
  },
  actions: {
    /**
     * carga la lista de los reportes del solarhub del cluster seleccionado
     */
    async loadReports({ commit }, { idCluster, idSolarHub }) {
      const reportListData = await getReportData(idCluster, idSolarHub);
      commit("updateReportList", reportListData);
    },
  },
  getters: {},
};
